import { Card, Col, Flex, Row, Statistic, Typography } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { FallOutlined, RiseOutlined, SunOutlined } from "@ant-design/icons";
import CountUp from "react-countup";

const { Text, Title } = Typography;

const Rise = () => (
  <RiseOutlined style={{ color: "var(--ant-color-success)", marginRight: 6 }} />
);

const Drop = () => (
  <FallOutlined style={{ color: "var(--ant-color-error)", marginRight: 6 }} />
);

const valueFormatter = (value) => {
  return value
    ? value >= 1000000
      ? value / 1000.0
      : value
    : value === 0
    ? value
    : null;
};

function PVGenerationHighlightCard({ currentValue = 0, lastValue = 0 }) {
  const numberFormat = { maximumFractionDigits: 1, minimumFractionDigits: 1 };

  return (
    <Card
      size="small"
      bordered
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      {/* <SunOutlined
        style={{
          position: "absolute",
          right: 24,
          top: 18,
          fontSize: 48,
          color: "var(--ant-orange)",
        }}
      /> */}
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex justify="start" align="end" gap={8}>
            <Statistic
              title={
                <Title level={5} style={{ margin: 0, marginBottom: 8 }}>
                  PV Generation
                </Title>
              }
              valueStyle={{
                fontSize: "var(--ant-font-size-heading-2)",
                fontWeight: "var(--ant-font-weight-strong)",
              }}
              value={valueFormatter(currentValue)}
              precision={2}
              formatter={(value) => (
                <CountUp
                  end={value}
                  separator=","
                  duration={1.5}
                  decimals={2}
                />
              )}
              suffix={
                <Title level={2} style={{ margin: 0 }} italic>
                  {currentValue >= 1000000
                    ? "MWh"
                    : currentValue === "N/A"
                    ? ""
                    : "kWh"}
                </Title>
              }
            ></Statistic>
          </Flex>
          <Flex justify="start" align="center" gap={4}>
            {currentValue > lastValue ? <Rise /> : <Drop />}
            <Text>
              {valueFormatter(lastValue)?.toLocaleString("en-US", numberFormat)}{" "}
              {lastValue >= 1000000 ? "MWh" : lastValue === "N/A" ? "" : "kWh"}
            </Text>
            <Text type="secondary">Last Month (To-Date)</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
    // <Card
    //   title={
    //     <Title level={5} style={{ margin: 0 }}>
    //       <SunOutlined style={{ marginRight: 12 }} />
    //       PV Generation
    //     </Title>
    //   }
    //   size="small"
    //   bordered
    // >
    //   <Row gutter={[12, 12]}>
    //     <Col span={24}>
    //       <Flex justify="start" align="end" gap={8}>
    //         <Title level={2} style={{ margin: 0 }}>
    //           {currentValue
    //             ? currentValue >= 1000000
    //               ? (currentValue / 1000.0).toLocaleString(
    //                   "en-US",
    //                   numberFormat
    //                 )
    //               : currentValue.toLocaleString("en-US", numberFormat)
    //             : currentValue === 0
    //             ? currentValue
    //             : " - "}
    //         </Title>
    //         <Title level={2} style={{ margin: 0 }} italic>
    //           {currentValue >= 1000000
    //             ? "MWh"
    //             : currentValue === "N/A"
    //             ? ""
    //             : "kWh"}
    //         </Title>
    //       </Flex>
    //     </Col>
    //     {/* <Col span={24}>
    //                 <Flex justify='end' align='center' gap={8}>
    //                     <Title level={4} style={{ margin: 0 }} type={ currentValue > lastValue ? 'success' : 'danger'}> { lastValue > currentValue ? <FallOutlined /> : <RiseOutlined />}
    //                     </Title>
    //                     <Text italic>Last :
    //                         {
    //                             lastValue?
    //                                 lastValue >= 1000000 ?
    //                                 (lastValue / 1000.0).toLocaleString('en-US', numberFormat)
    //                                 :
    //                                 lastValue.toLocaleString('en-US', numberFormat)
    //                             :
    //                             ' - '
    //                         }
    //                         <Text italic>{lastValue >= 1000000 ? 'MWh ': 'kWh '}</Text>
    //                         ( {
    //                             currentValue ? lastValue ? ((currentValue - lastValue) / lastValue).toLocaleString('en-US', { maximumFractionDigits: 1, style: 'percent' }) : ' - %' : ' - %'
    //                         } )
    //                     </Text>
    //                 </Flex>
    //             </Col> */}
    //   </Row>
    // </Card>
  );
}

export default PVGenerationHighlightCard;
